module.exports = __webpack_public_path__ + "media/images/fb-icon-26b5f24e76c54ceedc667c323ba449e5.png";